import { Component } from "react";
import { TriangleAlert } from "lucide-react";
import { StatusScreen } from "@/components/common/StatusScreen";
import { Button } from "@/components/ui/button";
import { captureException } from "@/services/analytics";

/** Catches render errors anywhere in the app and offers a reload. */
export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
    captureException(error, {
      errorType: "uiError",
      componentStack: errorInfo?.componentStack,
    });
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }
    return (
      <StatusScreen
        icon={TriangleAlert}
        tone="error"
        testId="error_boundary"
        title="Something went wrong"
        description="The interview page hit an unexpected error. Reloading usually fixes it."
        actions={
          <Button
            data-testid="reload_btn"
            onClick={() => window.location.reload()}
          >
            Reload
          </Button>
        }
      />
    );
  }
}
